type BrandTypography = {
  family: string
  fallback?: string
  weight?: number
  size: number
  lineHeight?: number
  style?: string
}

const stringifyTypography = (font: BrandTypography) => {
  let fontShorthand = ''
  if (font.style) fontShorthand += font.style
  if (font.weight) fontShorthand += ` ${font.weight}`
  fontShorthand += ` ${font.size}px`
  if (font.lineHeight !== undefined) fontShorthand += `/${font.lineHeight}`
  fontShorthand += ` ${JSON.stringify(font.family)}`
  if (font.fallback) fontShorthand += `,${font.fallback}`

  return fontShorthand.trim()
}

const parseTypography = (fontShorthand: string): BrandTypography => {
  const regex =
    /(?:(?<style>italic|normal|oblique)\s)?(?:(?<weight>\d{3})\s)?((?<size>\d+)px)?(?:\/(?<lineHeight>\d+(?:\.\d+)?))?\s+"(?<family>.+)"(?:,(?<fallback>[\w\s,-]+))?/
  const match = fontShorthand.match(regex)

  if (!match?.groups) {
    throw new Error('Invalid font shorthand format')
  }

  const { style, weight, size, lineHeight, family, fallback } = match.groups
  return {
    family,
    fallback,
    style,
    size: parseInt(size, 10),
    weight: weight ? parseInt(weight, 10) : undefined,
    lineHeight: lineHeight ? parseInt(lineHeight, 10) : undefined,
  }
}

export { type BrandTypography, stringifyTypography, parseTypography }
